/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/pin_medium'
export default icon
